module.exports = __webpack_public_path__ + "static/images/flag-singapore.2vC5YmS.svg";